import React, { useEffect } from 'react'
import styled from 'styled-components'

const SCALE = 8
const DURATION = 1.6
const SHARED_PING_COLOR = '#0ea5e9'

const Circle = styled.div`
    pointer-events: none;
    position: relative;
    z-index: 3;
    opacity: 0;
    position: absolute;
    width: 10px;
    height: 10px;
    border: 2px solid ${SHARED_PING_COLOR};
    border-radius: 150%;
    transition-property: opacity, transform;
    transition-duration: ${DURATION}s;
    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    will-change: transform, opacity;

    &.fade-grow-enter, &.fade-grow-appear {
        opacity: 1;
    }

    &.fade-grow-enter-active, &.fade-grow-appear-active {
        opacity: 0;
        transform: scale(${SCALE});
    }

    &.fade-grow-enter-done, &.fade-grow-appear-done {
        transform: scale(${SCALE});
        opacity: 0;
    }
`

const Ping = ({ onDestroy }) => {
    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            onDestroy()
        }, (DURATION * 1000) - 200)
        return () => {
            window.clearTimeout(timeoutId)
        }
    }, [])

    return (
        <Circle />
    )
}

export default Ping
